import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';
import mapStyle from '../../../../constants/mapStyle';

const ModuleSelectMap = ({ map, onMarkerClick }) => (
  <LoadScript googleMapsApiKey={import.meta.env.VITE_APP_GOOGLE_MAPS_KEY}>
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      zoom={map.zoom}
      center={{ lat: map.lat, lng: map.lng }}
      options={{
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        styles: mapStyle.worldlexDefault,
      }}
    >
      {map?.markers?.map((m) => (
        <Marker
          key={m.id}
          position={{ lat: m.lat, lng: m.lng }}
          title={m.name}
          icon={
            m.mapIcon?.url
              ? `https://worldlex.net/assets/images/mapIcon/${m.mapIcon.url}`
              : undefined
          }
          onClick={() => onMarkerClick(m)}
        />
      ))}
    </GoogleMap>
  </LoadScript>
);

export default ModuleSelectMap;
